var _path;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgGrain({
  title,
  titleId,
  ...props
}) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M11.11 2.238a3.439 3.439 0 012.517 0c.904.355 1.808.77 2.687 1.235.184.098.16.367-.036.44-4.813 1.688-8.27 6.273-8.27 11.677 0 1.675.33 3.29.94 4.744.086.208-.134.416-.33.318-.317-.159-.622-.33-.927-.513a25.868 25.868 0 01-3.14-2.152 3.49 3.49 0 01-1.258-2.177A24.29 24.29 0 013 12.02c0-1.296.098-2.555.293-3.79a3.49 3.49 0 011.258-2.177 25.868 25.868 0 013.14-2.152c1.111-.66 2.26-1.21 3.42-1.663zm9.089 3.79l-.342-.268a1.127 1.127 0 00-.855-.22c-5.228.953-9.198 5.538-9.198 11.053 0 1.712.378 3.338 1.062 4.793.11.22.306.391.538.477a3.462 3.462 0 002.223-.098 25.188 25.188 0 003.432-1.65 25.855 25.855 0 003.14-2.153 3.49 3.49 0 001.258-2.176c.195-1.235.293-2.507.293-3.79 0-1.296-.098-2.556-.293-3.79a3.523 3.523 0 00-1.258-2.177z",
    fill: "#00B96C"
  })));
}

export default SvgGrain;